import React, { useState } from 'react'
import { Container, Breadcrumb, BreadcrumbItem, Row, Col, Badge, Button, Modal, ModalBody,ModalHeader, ModalFooter } from 'reactstrap'
import { NavLink } from 'react-router-dom'
import OtpInput from 'react-otp-input';


import { homePageUrl } from '../../../helpers/Constants'

function LegislationCompiled() {
    let [modal, setModal] = useState(false);
    let [otp, setOtp] = useState('')

    const customModal = () => {
        console.log("method called", modal);    
        setModal(!modal)
    };

    const handleChange = (otp) => setOtp(otp);

  return (
    <>
    <section className='lyt-section'>
        <Container fluid className='typ-container'>
            <Breadcrumb className='bs-breadcrumb mt-0'>
                <BreadcrumbItem><NavLink to={`reports`}>Reports</NavLink></BreadcrumbItem>
                <BreadcrumbItem active>Legislation</BreadcrumbItem>
            </Breadcrumb>
            <Row>
                <Col xs={12} sm={12} md={12} lg={9} xl={8}>
                    <ul className='bs-list typ-green-tick'>
                        <li><NavLink to={`legislation1`}>Legislation 1<Badge color="green"><i className='icon icon-tick'></i></Badge></NavLink></li>
                        <li><NavLink to={`legislation1`}>Legislation 2<Badge color="green"><i className='icon icon-tick'></i></Badge></NavLink></li>
                        <li><NavLink to={`legislation1`}>Legislation 3<Badge color="green"><i className='icon icon-tick'></i></Badge></NavLink></li>
                        <li><NavLink to={`legislation1`}>Legislation 4<Badge color="green"><i className='icon icon-tick'></i></Badge></NavLink></li>
                        <li><NavLink to={`legislation1`}>Legislation 5<Badge color="green"><i className='icon icon-tick'></i></Badge></NavLink></li>
                        <button className='bs-btn btn-submit' onClick={()=>customModal()}>SUBMIT</button>
                    </ul>
                    
                </Col>
            </Row>
        </Container>
    </section>
    <Modal isOpen={modal} toggle={customModal} size={'lg'} centered={true} className='bs-modal typ-otp'>
        <ModalHeader toggle={customModal}>
            <h2 className='bs-heading typ-modal'>Enter the 4-digit code sent to +91******7925</h2>
        </ModalHeader>
        <ModalBody toggle={customModal}>
            <p className='bs-para typ-black mb-0'>OTP</p>
            <div className='mod-otp'>
                <OtpInput
                    value={otp}
                    onChange={handleChange}
                    numInputs={4}
                />
            </div>
            <button className='bs-btn typ-resend'>Resend OTP</button>
        </ModalBody>
        <ModalFooter>
            <button onClick={customModal} className='bs-btn typ-replace min-width margin-right'>
            SUBMIT
            </button>{' '}
            <div className='mod-divider typ-or'></div>
            <button onClick={customModal} className='bs-btn typ-gray'>
            SEND OTP ON EMAIL ID
            </button>
        </ModalFooter>
    </Modal>
    </>
  )
}

export default LegislationCompiled
